import { createSlice } from '@reduxjs/toolkit';
const initialState ={};
const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    updateAuth: (state, action) => {
      return action.payload;
    },
    updatePreferredLn: (state, action) => {
      state.preferredLang = action.payload
    }
  },
});
export const { updateAuth, updatePreferredLn } = dataSlice.actions;
export const getAuth = (state) => state.updateAuth;
export default dataSlice.reducer;